import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CapturumSharedModule, MapItem, ObservablePipe } from '@capturum/ui/api';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { SortAlphabeticallyPipe } from '@shared/pipes/sort-alphabetically.pipe';
import { interpolationRegex } from '@shared/utils/regex.util';
import { DndDropEvent, DndModule } from 'ngx-drag-drop';
import { Select } from 'primeng/select';
import { BehaviorSubject, isObservable } from 'rxjs';

@Component({
  selector: 'app-droppable-dropdown',
  imports: [
    DndModule,
    FormlyModule,
    ReactiveFormsModule,
    AsyncPipe,
    CapturumSharedModule,
    Select,
    TranslateModule,
    SortAlphabeticallyPipe,
    ObservablePipe,
  ],
  templateUrl: './droppable-dropdown.component.html',
})
export class DroppableDropdownTypeComponent extends FieldType implements OnInit {
  override defaultOptions = {
    props: {
      appendTo: 'body',
      sortAlphabetically: true,
      sortBy: 'label',
      filterBy: 'label',
      filter: true,
      virtualScroll: true,
      showClear: true,
      virtualScrollItemSize: 30,
      emptyFilterMessage: 'No results found',
      scrollHeight: '200px',
      name: '',
      inputId: '',
      selectId: '',
      dataKey: '',
      style: null,
      panelStyle: null,
      styleClass: '',
      panelStyleClass: '',
      editable: false,
      autofocus: false,
      resetFilterOnHide: false,
      dropdownIcon: 'mynaui-chevron-down',
      optionLabel: 'label',
      autoDisplayFirst: false,
      group: false,
      ariaFilterLabel: '',
      withImages: false,
      openOnFocus: false,
      hasTooltip: false,
      optionValue: 'value',
      autofocusFilter: true,
      tabindex: 0,
    },
  };

  get panelStyleClass(): string {
    return `cap-dropdown-panel ${this.props.panelStyleClass || ''}`;
  }

  get styleClass(): string {
    return `cap-dropdown ${this.props.styleClass || ''}`;
  }

  #dropdownOptions = new BehaviorSubject<MapItem[]>([]);

  ngOnInit(): void {
    if (!isObservable(this.props.options)) {
      this.#dropdownOptions.next(this.props.options || []);
      this.props.options = this.#dropdownOptions.asObservable();
    }
  }

  onDrop(event: DndDropEvent): void {
    const inOptions = this.#dropdownOptions.value?.find((option) => {
      const data = option.value.match(interpolationRegex) ? `{{${event.data}}}` : event.data;

      return option.value === data;
    });

    if (inOptions) {
      this.formControl.setValue(inOptions.value);
    }
  }
}
